// Modern Web Audio Notification Sounds Engine
export interface SoundPreset {
  id: number
  name: string
  description: string
  category: string
}

export const SOUND_PRESETS: SoundPreset[] = [
  { id: 0, name: "Zenith Crystal Chime", description: "Yumshoq kristal akkordi", category: "Klassik" },
  { id: 1, name: "Apple Glass Ping", description: "Tiniq va yoqimli ping", category: "Zamonaviy" },
  { id: 2, name: "Gentle Bubble Pop", description: "Yengil pufakcha sadosi", category: "Yumshoq" },
  { id: 3, name: "Success Melody", description: "Muvaffaqiyatli operatsiya ohangi", category: "Muvaffaqiyat" },
  { id: 4, name: "Marimba Warm Tap", description: "Issiq yog'och zarbasi", category: "Tabiiy" },
  { id: 5, name: "Smooth Harp Strum", description: "Arfa torlari sadosi", category: "Klassik" },
  { id: 6, name: "Cyber Tech Pulse", description: "Futuristik texno signal", category: "Texno" },
  { id: 7, name: "Ambient Echo Ding", description: "Aks-sado beruvchi mayin qo'ng'iroq", category: "Mayin" },
  { id: 8, name: "Executive Triple Tone", description: "Uch bosqichli professional signal", category: "Biznes" },
  { id: 9, name: "Futuristic Spark", description: "Yorqin mikro-blip sadosi", category: "Ultra" },
]

export const playNotificationSound = (soundIndex?: number) => {
  try {
    const isSoundEnabled = localStorage.getItem("crm_sound_enabled") !== "false"
    if (!isSoundEnabled) return

    const selectedIdx =
      soundIndex !== undefined
        ? soundIndex
        : parseInt(localStorage.getItem("crm_selected_sound") || "0", 10)

    const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext
    if (!AudioContextClass) return

    const ctx = new AudioContextClass()
    const now = ctx.currentTime

    const playTone = (
      freq: number,
      startTime: number,
      duration: number,
      type: OscillatorType = "sine",
      gainVal: number = 0.15
    ) => {
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()
      osc.type = type
      osc.frequency.setValueAtTime(freq, startTime)
      gain.gain.setValueAtTime(gainVal, startTime)
      gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration)
      osc.connect(gain)
      gain.connect(ctx.destination)
      osc.start(startTime)
      osc.stop(startTime + duration)
    }

    switch (selectedIdx) {
      case 0: // Zenith Crystal Chime
        playTone(523.25, now, 0.4, "sine", 0.15) // C5
        playTone(659.25, now + 0.08, 0.5, "sine", 0.14) // E5
        playTone(783.99, now + 0.16, 0.6, "sine", 0.12) // G5
        playTone(1046.5, now + 0.24, 0.8, "sine", 0.1) // C6
        break

      case 1: // Apple Glass Ping
        playTone(1318.51, now, 0.25, "sine", 0.2) // E6
        playTone(1567.98, now + 0.06, 0.35, "sine", 0.15) // G6
        break

      case 2: // Gentle Bubble Pop
        playTone(400, now, 0.05, "sine", 0.2)
        playTone(880, now + 0.03, 0.15, "sine", 0.15)
        break

      case 3: // Success Melody
        playTone(440, now, 0.2, "triangle", 0.15) // A4
        playTone(554.37, now + 0.1, 0.2, "triangle", 0.15) // C#5
        playTone(659.25, now + 0.2, 0.4, "triangle", 0.18) // E5
        playTone(880, now + 0.3, 0.6, "sine", 0.15) // A5
        break

      case 4: // Marimba Warm Tap
        playTone(392.0, now, 0.2, "sine", 0.25) // G4
        playTone(587.33, now + 0.06, 0.25, "sine", 0.2) // D5
        break

      case 5: // Smooth Harp Strum
        playTone(329.63, now, 0.3, "sine", 0.12)
        playTone(392.0, now + 0.05, 0.3, "sine", 0.12)
        playTone(493.88, now + 0.1, 0.35, "sine", 0.12)
        playTone(587.33, now + 0.15, 0.4, "sine", 0.12)
        playTone(659.25, now + 0.2, 0.6, "sine", 0.15)
        break

      case 6: // Cyber Tech Pulse
        playTone(800, now, 0.08, "sawtooth", 0.08)
        playTone(1200, now + 0.06, 0.12, "sawtooth", 0.08)
        playTone(1600, now + 0.12, 0.2, "sine", 0.12)
        break

      case 7: // Ambient Echo Ding
        playTone(880, now, 0.8, "sine", 0.18)
        playTone(1760, now + 0.02, 0.6, "sine", 0.06)
        break

      case 8: // Executive Triple Tone
        playTone(523.25, now, 0.12, "sine", 0.15)
        playTone(659.25, now + 0.1, 0.12, "sine", 0.15)
        playTone(783.99, now + 0.2, 0.3, "sine", 0.18)
        break

      case 9: // Futuristic Spark
        playTone(1046.5, now, 0.06, "sine", 0.15)
        playTone(2093.0, now + 0.04, 0.2, "sine", 0.12)
        break

      default:
        playTone(587.33, now, 0.3, "sine", 0.15)
        break
    }
  } catch (err) {
    console.warn("Audio play warning:", err)
  }
}
